const sectionTableKuboCss = `
[data-type='section-table-kubo'] [data-attribute='wrapper-container'] {
  padding: 40px 0;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

[data-type='section-table-kubo'] .title-content h1,
[data-type='section-table-kubo'] .title-content h2,
[data-type='section-table-kubo'] .title-content h3 {
  font-size: 24px;
}

[data-type='section-table-kubo'] .wrap-table {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

[data-type='section-table-kubo'] .wrap-table figure {
  overflow-x: auto;
  overflow-y: hidden;
  width: 100% !important;
}

[data-type='section-table-kubo'] .wrap-table table {
  border-collapse: separate;
  border-spacing: 0px 10px;
  width: 100% !important;
}

[data-type='section-table-kubo'] .wrap-table table p {
  margin-bottom: 8px !important;
}

[data-type='section-table-kubo'] .wrap-table table img {
  width: 24px;
  height: 24px;
  object-fit: cover;
}

[data-type='section-table-kubo'] .wrap-table table thead tr th:first-child {
  border-top-left-radius: 10px;
}

[data-type='section-table-kubo'] .wrap-table table thead tr th:last-child {
  border-top-right-radius: 10px;
}

[data-type='section-table-kubo'] .wrap-table table thead tr th p {
  margin-bottom: 0 !important;
}

[data-type='section-table-kubo'] .wrap-table table tbody tr:nth-child(odd) {
  background-color: #f2f2f2;
}

@container (max-width: 768px) {
  [data-type='section-table-kubo'] [data-attribute='wrapper-container'] {
    padding: 16px 0;
  }

  [data-type='section-table-kubo'] .title-content h1,
  [data-type='section-table-kubo'] .title-content h2,
  [data-type='section-table-kubo'] .title-content h3 {
    font-size: 16px;
  }
}
`;
export default sectionTableKuboCss;
